import React from "react";
import clsx from "clsx";
import PropTypes from "prop-types";
import { Modal, ModalBody, ModalFooter, ModalHeader } from "react-bootstrap";

const CenterModal = ({ showModal, className, header, body, footer, ...otherProps }) => {
    const styles = clsx(className || "");
    const modalClass = clsx("", otherProps.modalClass ? otherProps.modalClass : "");

    const closeModal = () => {
        otherProps.closeModal();
    };

    return (
        <div>
            <Modal
                show={showModal}
                keyboard={!otherProps?.keyboard}
                onHide={closeModal}
                dialogClassName={styles}
                className={modalClass}
                backdrop={otherProps?.backdrop}
            >
                {header?.props?.children?.length > 0 && <ModalHeader>{header}</ModalHeader>}
                {body && <ModalBody className={clsx(otherProps.bodyClassName ? otherProps.bodyClassName : "")}>{body}</ModalBody>}
                {footer && <ModalFooter className={clsx(otherProps.footerClassName ? otherProps.footerClassName : "")}>{footer}</ModalFooter>}
            </Modal>
        </div>
    );
};

CenterModal.propTypes = {
    showModal: PropTypes.bool,
    className: PropTypes.string,
    header: PropTypes.object,
    body: PropTypes.object,
    footer: PropTypes.oneOfType([PropTypes.object, PropTypes.bool]),
};

export default CenterModal;
